import React, { useState, useEffect } from "react";
import AccountList from "../accountList/AccountList";
import Select from "react-select";
import { connect } from "react-redux";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Input, Checkbox, Icon, Radio, Popup } from "semantic-ui-react";

import { ReactComponent as SearchIcon } from "../../../../../assets/svg/search.svg";
import { ReactComponent as CaneclIcon } from "../../../../../assets/svg/close.svg";

import "../PlatformConfig.scss";

import { fetchFbTokenList, storeFbSocialToken } from "../../../../../actions/tokensAction";
import { gettingStartedProgress } from "../../../../../actions/globalAction";
import { addFbComment, countryList, deleteFBComment, fetchFBComments } from "../../../../../actions/facebookCommentsAction";
import DeletePostModal from "../../../../SettingsContainer/FacebookComments/DeletePostsModal/DeletePostModal";
import CommentsList from "../../../../SettingsContainer/FacebookComments/CommentsList/CommentsList";
import SocialTokenScopeModal from "../../../Tokens/SocialTokenScopeModal";

function AdditionalDataFacebook(props) {
    const [configureMode, setConfigureMode] = useState({ label: "Facebook Page", value: "Account" });
    const [openPermissionModal, setOpenPermissionModal] = useState(false);

    useEffect(() => {
        props.fetchFBComments();
        props.fetchFbTokenList();
    }, []);

    useEffect(() => {
        if (
            props.validAccounts &&
            props.validAccounts[0]?.account_exist &&
            (props.validAccounts[0]?.details[0].name.toLowerCase() === props.accountName.toLowerCase() ||
                props.validAccounts[0]?.details[0].name.toLowerCase() === props.post_url.toLowerCase())
        ) {
            let country;
            let entity;
            if (props.validAccounts[0].details[0].country_id)
                country = props.getCountryList().find((val) => val.value === props.validAccounts[0].details[0].country_id);
            if (props.validAccounts[0].details[0].entity_sub_type)
                entity = props.entityList.find((val) => val.value === props.validAccounts[0].details[0].entity_sub_type);

            props.setValidCountry(country);
            props.setValidEntity(entity);
        }
    }, [props.validAccounts]);

    useEffect(() => {
        props.setValidCountry(null);
    }, [props.location, props.post_country]);

    useEffect(() => {
        props.setValidEntity(null);
    }, [props.entityType]);

    useEffect(() => {
        if (configureMode.value === "fbcomment") props.setIsFbComment(true);
    }, [configureMode]);

    const configureModeList = [
        { label: "Facebook Page", value: "Account" },
        { label: "FB Comments", value: "Posts" },
    ];

    const handleConfigureMode = (value) => {
        setConfigureMode(value);
    };

    return (
        <div className="additionalDataInstagram">
            <section className="parentSection">
                <div className="addAccountBlock">
                    <div className="authenticateSection">
                        <section className="leftSection">
                            <Popup
                                inverted
                                content="Facebook"
                                style={{ backgroundColor: "#1f2e3d" }}
                                trigger={
                                    <div>
                                        <img src={props.icon} className="platformIcon" alt="facebook icon" />
                                    </div>
                                }
                            />

                            {props.fbTokenList.length === 0 ? (
                                <div className="authenticateRefresh fbConfigure_step1">
                                    <p className="common__btn" onClick={() => setOpenPermissionModal(true)}>
                                        Authenticate
                                    </p>
                                    <p onClick={props.fetchFbTokenList}>
                                        <Popup
                                            className="skiptranslate"
                                            trigger={<Icon name="refresh" size="large" />}
                                            content="Refresh"
                                            inverted
                                            position="bottom center"
                                            size="mini"
                                        />
                                    </p>
                                </div>
                            ) : (
                                <div className="validToken fbConfigure_step1">
                                    <p>
                                        <Icon color="green" name="check" />
                                    </p>
                                    <p>Valid token found</p>
                                </div>
                            )}
                            <SocialTokenScopeModal
                                open={openPermissionModal}
                                onClose={() => setOpenPermissionModal(false)}
                                platform={{ name: "facebook" }}
                                storeFbSocialToken={props.storeFbSocialToken}
                                packageObj={props.packageObj}
                            />
                        </section>
                        <div onClick={props.closeComponent} className="fbConfigure_step3">
                            <button className="common__btn ml-1 backButton">Back to Social Accounts</button>
                        </div>
                    </div>
                    {props.fbTokenList.length === 0 && (
                        <div className="requestAuthenticateBlock">
                            <div className="warningMessage">
                                <p>
                                    <Icon name="warning sign" color="red" />
                                </p>
                                <p>Missing token</p>
                            </div>
                            <p>
                                You cannot configure accounts or pages for this platform as you have not authenticated yet. Please click on the
                                &quot;Authenticate&quot; button above. This will open a new window where you can authenticate. Once done you can come back to
                                this page and configure your accounts.
                            </p>
                        </div>
                    )}

                    <section className={`add_account-form  ${props.fbTokenList.length === 0 && "disablePlatform"}`}>
                        {configureMode.value === "Posts" ? (
                            <div className="field__row-normal m-10">
                                In this section, you can configure facebook posts from which you would like to see data in the Radarr platform. Once you
                                configure a post using the post URL, we will fetch all comments from those posts. This section is useful when you brand has been
                                mentioned in a Facebook page and you want to actively track the comments from that page.
                            </div>
                        ) : (
                            <div className="field__row-normal m-10">
                                In this section, you can configure facebook page(s) from which you would like to see data in the Radarr platform. Once you
                                configure a page, we will fetch all posts and comments in those posts going forward. This section is useful for tracking your
                                own pages as well as any other pages you would like to actively track.
                            </div>
                        )}

                        <div className="field__row m-10">
                            <div className="field__wrap fbConfigure_step2">
                                <label>Configure*</label>
                                <Select
                                    className="platform-list"
                                    value={configureMode}
                                    options={configureModeList}
                                    onChange={handleConfigureMode}
                                    maxMenuHeight={140}
                                    styles={props.customStyle}
                                    components={{ IndicatorSeparator: () => null }}
                                />
                            </div>
                            {configureMode.value === "Posts" ? (
                                <>
                                    <div className="field__wrap">
                                        <label>Facebook Post*</label>
                                        <Input
                                            type="text"
                                            className="add-facebookPost-input"
                                            placeholder="https://www.facebook.com/bbcnews/posts/10156539901572217"
                                            onChange={(e) => props.handlePostUrlChange(e)}
                                            value={props.post_url}
                                        />
                                    </div>

                                    {props.isAccountValid && (
                                        <div className="field__wrap">
                                            <label>Country*</label>
                                            <Select
                                                options={props.getCountryList()}
                                                className="platform-list"
                                                placeholder="Select Country"
                                                isClearable={true}
                                                value={props.validCountry || props.post_country}
                                                onChange={props.handlePostCountryChange}
                                                maxMenuHeight={230}
                                                formatOptionLabel={props.formatOptionLabel}
                                                styles={props.customStyle}
                                                components={{ IndicatorSeparator: () => null }}
                                            />
                                        </div>
                                    )}

                                    {/* <div className="field__row-normal m-20">
                                        <button className="common__btn offset-hieight" onClick={() => props.onAddAccount(true)}>
                                            <span> Add </span>
                                        </button>

                                       <button className="common__btn ml-10 offset-hieight inactive" onClick={() => onCancelPost()}>
                                            <span> Cancel </span>
                                        </button> 
                                    </div> */}
                                </>
                            ) : (
                                <>
                                    <div className="field__wrap">
                                        <label>Account Name*</label>
                                        <input
                                            type="text"
                                            className="add__input"
                                            placeholder="Enter Account name"
                                            value={props.accountName}
                                            onChange={(e) => props.handleUrlChange(e)}
                                        />
                                    </div>

                                    {props.isAccountValid && (
                                        <>
                                            <div className="field__wrap">
                                                <label>Location</label>
                                                <Select
                                                    className="platform-list"
                                                    value={props.validCountry || props.location}
                                                    isSearchable
                                                    placeholder="Select Location"
                                                    options={props.getCountryList()}
                                                    onChange={props.handleLocationChange}
                                                    formatOptionLabel={props.formatOptionLabel}
                                                    maxMenuHeight={140}
                                                    styles={props.customStyle}
                                                    isClearable
                                                    components={{ IndicatorSeparator: () => null }}
                                                />
                                            </div>
                                            <div className="field__wrap">
                                                <label>Entity Type</label>
                                                <Select
                                                    className="platform-list"
                                                    value={props.validEntity || props.entityType}
                                                    isSearchable
                                                    placeholder="Select Entity Type"
                                                    options={props.entityList}
                                                    onChange={props.handleEntityTypeChange}
                                                    maxMenuHeight={140}
                                                    styles={props.customStyle}
                                                    isClearable
                                                    components={{ IndicatorSeparator: () => null }}
                                                />
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </section>

                    {configureMode.value !== "Posts" && (
                        <div className="field__row-normal m-20">
                            <Checkbox className="mr-10" checked={props.isPublication} onChange={() => props.setPublication()} />
                            <p>Please Select if this is a News Publication (Eg. Wall Street Journal Facebook Page, Wall Street Journal Blog Etc).</p>
                        </div>
                    )}

                    {configureMode.value !== "Posts" && (
                        <div className="field__row-normal m-10">
                            <Radio
                                label="Fetch only posts"
                                name="radioGroup"
                                value={false}
                                checked={!props.isFbComment}
                                onChange={(e, { value }) => props.setIsFbComment(value)}
                            />

                            <Radio
                                label="Fetch posts and comments"
                                name="radioGroup"
                                value={true}
                                checked={props.isFbComment}
                                onChange={(e, { value }) => props.setIsFbComment(value)}
                            />
                        </div>
                    )}

                    {/* {configureMode.value !== "Posts" && ( */}
                    <div className={`field__row-normal m-20 ${props.fbTokenList.length === 0 && "disablePlatform"}`}>
                        <button className="common__btn offset-hieight" onClick={() => props.verifyAccount(configureMode.value === "Posts")}>
                            <span> {props.verifyingAccount ? <Loader active size="small" /> : ""} Verify </span>
                        </button>
                        <p className="ml-1">*Validate to continue account Configuration</p>

                        <button
                            className="common__btn ml-10 offset-hieight"
                            disabled={!props.isAccountValid}
                            onClick={() => props.onAddAccount(configureMode.value === "Posts")}>
                            <span> {props.addingAccount ? <Loader active size="small" /> : ""} Add </span>
                        </button>
                    </div>
                    {/* // )} */}
                    {/* 
                    {configureMode.value === "Posts" && (
                        <div
                            className={`igConfigurations ${props.fbTokenList.length === 0 && "disablePlatform"}`}
                            style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
                            <div className="igconfigurations__wrapper-header-right">
                                <div className="igconfigurations-search ig_step4">
                                    <span>
                                        <SearchIcon />
                                    </span>
                                    <input type="text" placeholder="Search" onChange={props.onSearchTextChange} value={props.searchTextValue} />
                                    {props.searchTextValue && (
                                        <span className="cancel__wrap">
                                            <span
                                                className="cancel-search"
                                                onClick={() => {
                                                    props.clearSearchFilter();
                                                }}>
                                                <CaneclIcon />
                                            </span>
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    )} */}

                    <section className={`account__list-table ${props.fbTokenList.length === 0 && "disablePlatform"}`}>
                        <AccountList
                            isAccountAdded={props.isAccountAdded}
                            accountListData={props.accountListData}
                            deleteAccount={props.deleteAccount}
                            allLocations={props.allLocations}
                        />
                    </section>
                </div>
                <div className="saveAndContinue">
                    <button
                        className="common__btn"
                        disabled={props.accountListData.length === 0 && props.postListData.length === 0}
                        onClick={props.closeComponent}>
                        Save and continue
                    </button>
                </div>
            </section>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        countryList: state.fbCommentsReducer.countryList,
        fbTokenList: state.tokensReducer.fbTokenList,
        packageObj: state.globalReducer.packageObj,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        storeUserFbToken: (params) => dispatch(storeFbToken(params)),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        fetchFBComments: () => dispatch(fetchFBComments()),
        addFbComment: (params) => dispatch(addFbComment(params)),
        deleteFBComment: (params) => dispatch(deleteFBComment(params)),
        fetchQBCountryList: () => dispatch(countryList()),
        fetchFbTokenList: () => dispatch(fetchFbTokenList()),
        storeFbSocialToken: (data) => dispatch(storeFbSocialToken(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalDataFacebook);
